/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './version.dto';
export * from './version.mapper';
export * from './version-rest.service';
